import { useContext } from "react";
import { ErrorContext } from "~/components/error.context";

export const useError = () => useContext(ErrorContext);
